module.exports = __webpack_public_path__ + "img/253-seychelles.e6288046.svg";